




























































import PageSkeleton from '@/components/page-skeleton.vue';
import UpgradeDialog from '@/components/upgrade-dialog.vue';
import { useGlobalData } from '@/hooks/use-global-data';
import { useRecommend } from '@/hooks/use-recommend';
import { i18n } from '@/i18n';
import { useConfigStore } from '@/store/config';
import { to } from '@/utils';
import { getServerTime, getMonthPeriod } from '@/utils/date-helper';
import { CustomException, elk, windowHelper } from '@tencent/ppd-base-libs';
import { showErrorDialog } from '@tencent/wphk-act-base-ui';
import { BaseComponent } from '@tencent/wphk-components-content-loader';
import { showDialog } from '@tencent/wphk-components-dialog';
import { defineComponent, onMounted, ref, unref } from '@vue/composition-api';
import RecommendDialog from '../components/activity-module/coupon-module/recommend-dialog/recommend-dialog.vue';
import ActivityModule from '../components/activity-module/index.vue';
import GuideModule from '../components/guide-module/index.vue';
import HeaderModule from '../components/header-module/index.vue';
import AdBanner from '../components/ad-module/ad-banner.vue';
import TncModule from '../components/tnc-module/index.vue';
import TopScrollNotice from '../components/top-scroll-notice.vue';
import { useBlockDialog } from '../hooks/use-block-dialog';
import { useDialogManager } from '../hooks/use-dialog-manager';
import HalfStampIndexVue from '@/components/stamp-module/half-stamp-index.vue';
import TaskSummaryVue from '@/components/activity-module/task-module/task-summary.vue';
import HalfTaskIndexVue from '@/components/activity-module/task-module/half-task-index.vue';
import { useStampStore } from '@/store/stamp';
import dayjs from 'dayjs';
import { storeToRefs } from 'pinia';
import ThemeNotice from '@/components/common/theme-notice.vue';
import { useGrayStore } from '@/store/gray';
import ChannelCouponDialog from '../components/channel-coupon-dialog/index.vue';
import { ChannelKey } from '../components/channel-coupon-dialog/use-channel-coupon-dialog';

export default defineComponent({
  name: 'Home',
  components: {
    HeaderModule,
    ActivityModule,
    TncModule,
    TopScrollNotice,
    UpgradeDialog,
    GuideModule,
    RecommendDialog,
    BaseComponent,
    PageSkeleton,
    HalfStampIndexVue,
    TaskSummaryVue,
    HalfTaskIndexVue,
    ThemeNotice,
    AdBanner,
    ChannelCouponDialog,
  },

  setup() {
    const configStore = useConfigStore();
    const globalData = useGlobalData();
    const blockDialog = useBlockDialog();
    const stampStore = useStampStore();
    const grayStore = useGrayStore();
    const { remainCount } = storeToRefs(stampStore);
    const { isGrayUser } = storeToRefs(grayStore);

    const { init: initRecommend } = useRecommend();
    const { handleAllDialog, handleCouponTaskDialog } = useDialogManager();

    const isShow = ref(false);
    const isLoadConfig = ref(false);

    // 是否显示月底印花过期提示
    const isShowTip = ref(true);

    onMounted(() => {
      const last7StartTimeStamp = dayjs(getMonthPeriod().lastDate).subtract(6, 'day')
        .startOf('day')
        .valueOf();
      const last7EndTimeStamp = dayjs(getMonthPeriod().lastDate).valueOf();
      const currentTimeStamp = getServerTime().valueOf();
      isShowTip.value = currentTimeStamp >= last7StartTimeStamp && currentTimeStamp <= last7EndTimeStamp;
    });

    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const handleConfigInitError = (e) => {
      const errMsg = '配置異常，請重試';
      showErrorDialog({
        message: errMsg,
      });
      try {
        elk({
          key: 'showErrorDialog',
          str2: 'configError',
          str3: errMsg,
          msg: JSON.stringify(e),
        });
      } catch (e) {}
    };

    /** 总init */
    const initBusiness = async () => {
      // 拉取业务数据
      const [refreshErr] = await to(globalData.refresh());
      if (refreshErr) {
        // 产品要求限流的时候弹窗刷新页面
        const isNeedReloadPage = refreshErr.retcode === '1039168000';
        globalData.handleRefreshError(refreshErr, { isNeedReloadPage });
        throw refreshErr;
      }
      isShow.value = true;
    };

    const initStore = async () => {
      const [err] = await to(configStore.init());
      if (err) {
        handleConfigInitError(err);
        throw err;
      }
    };

    // 拉取灰度数据
    const initGrayStore = async () => {
      const [err] = await to(grayStore.init());
      if (err) {
        new CustomException(err, 'initGrayStoreErr', '初始化灰度数据失败');
      }
    };

    // 校验并弹出阻断弹窗
    const checkAndShowBlockDialog = () => {
      if (blockDialog.isInBlockPeriod.value) {
        showDialog({
          title: i18n('溫馨提示'),
          content: unref(blockDialog.blockText.value),
          btns: [
            {
              text: i18n('好的'),
              click: () => {
                const ADTAG = 'eStampBlockDialog';
                windowHelper.replace(`https://prom.wechatpay.com.hk/discount-center/coupon_home.shtml?ADTAG=${ADTAG}`);
              },
            },
          ],
        });
        elk({
          key: 'blockDialogShow',
          str2: getServerTime(),
          str3: blockDialog.blockText.value,
        });
        return true;
      }
      return false;
    };

    onMounted(async () => {
      document.title = i18n('每月狂賞印');

      try {
        // 初始化配置 + 拉取灰度数据
        await Promise.all([initStore(), initGrayStore()]);
        // 校验并展示阻断弹窗
        if (checkAndShowBlockDialog()) {
          return;
        }
        // 展示骨架屏
        isLoadConfig.value = true;
        // 總init
        await initBusiness();
        // 主動執行任務
        await globalData.autoExecTask();
        // 初始化推荐弹窗
        await initRecommend();
        // 处理多个关联弹窗逻辑
        await handleAllDialog();
        // 处理券 or 任务详情弹窗逻辑
        await handleCouponTaskDialog();
      } catch (e) {
        new CustomException(e, 'eStampInitFail', '狂赏印页面init失败');
      }
    });

    return {
      isGrayUser,
      isShow,
      isLoadConfig,
      isShowTip,
      remainCount,
      ChannelKey,
    };
  },
});
